import { AfterViewInit, Directive, ElementRef, HostListener, inject, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appMaxLength]',
    standalone: false
})
export class MaxLengthDirective implements AfterViewInit {
  @Input('appMaxLength') maxLength?: number;
  private ngControl = inject(NgControl);
  private element: HTMLInputElement;

  constructor(private el: ElementRef) {
    this.element = this.el.nativeElement;
  }

  ngAfterViewInit(): void {
    // Only set maxLength attribute if maxLength is defined and is a valid number
    if (this.isMaxLengthDefined()) {
      this.element.setAttribute('maxlength', this.maxLength!.toString());
      if (this.ngControl.value) {
        this.trimValue(this.ngControl.value);
      }
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (this.isMaxLengthDefined()) {
      const input = event.target as HTMLInputElement;
      const value = input.value;

      if (value.length > this.maxLength!) {
        const trimmedValue = value.substring(0, this.maxLength);
        this.updateValue(trimmedValue);
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (this.isMaxLengthDefined()) {
      const clipboardData = event.clipboardData?.getData('text') || '';
      const currentValue = this.element.value;
      const selectionStart = this.element.selectionStart || 0;
      const selectionEnd = this.element.selectionEnd || 0;

      const newValue = currentValue.substring(0, selectionStart) + clipboardData + currentValue.substring(selectionEnd);

      if (newValue.length > this.maxLength!) {
        const trimmedValue = newValue.substring(0, this.maxLength);
        this.updateValue(trimmedValue);
        event.preventDefault();
      }
    }
  }

  private trimValue(value: string): void {
    if (this.isMaxLengthDefined() && value.length > this.maxLength!) {
      const trimmedValue = value.substring(0, this.maxLength);
      this.updateValue(trimmedValue);
    }
  }

  private updateValue(value: string): void {
    this.element.value = value;
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(value);
    }
  }

  // Helper method to check if maxLength is defined
  private isMaxLengthDefined(): boolean {
    return this.maxLength !== undefined && this.maxLength !== null && !isNaN(this.maxLength);
  }
}